import { render, staticRenderFns } from "./Spheres.vue?vue&type=template&id=3701cde2&scoped=true&"
import script from "./Spheres.vue?vue&type=script&lang=js&"
export * from "./Spheres.vue?vue&type=script&lang=js&"
import style0 from "./Spheres.vue?vue&type=style&index=0&id=3701cde2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3701cde2",
  null
  
)

export default component.exports